import { __rest } from 'tslib';
import { jsxs, jsx } from 'react/jsx-runtime';
import classNames from 'classnames';

var RocketIllustration = function RocketIllustration(_a) {
  var className = _a.className,
    _a$color = _a.color,
    color = _a$color === undefined ? 'sapphire' : _a$color,
    otherProps = __rest(_a, ["className", "color"]);
  return jsxs("svg", Object.assign({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-label": "RocketIllustration",
    role: "img",
    viewBox: "0 0 112 72",
    xmlns: "http://www.w3.org/2000/svg",
    width: "112",
    height: "72",
    fill: "none",
    className: classNames('cogs-illustration', 'cogs-themed-icon', className)
  }, otherProps, {
    children: [jsx("g", {
      fill: "var(--cogs-decorative--".concat(color, "--400)"),
      opacity: ".3",
      children: jsx("path", {
        d: "M53.088 12.32 39.232 8.607a1 1 0 0 0-.758.1L19.89 19.436c-.772.445-.62 1.601.241 1.832l13.856 3.713a1 1 0 0 0 .758-.1L53.33 14.15c.772-.444.62-1.6-.241-1.831M14.494 54.628l-1.051 2.182 2.416.182c10.128.759 23.788-3.214 21.673-11.285L64.268 30.27a1 1 0 0 0 .366-1.366l-1.428-2.475a1 1 0 0 0-1.366-.366L35.104 41.5c-5.932-5.867-16.204 3.977-20.61 13.128M68.083 58.577l3.712-13.855c.23-.86-.694-1.57-1.466-1.125L51.747 54.326a1 1 0 0 0-.466.607l-3.713 13.856c-.23.86.695 1.57 1.466 1.124l18.583-10.728a1 1 0 0 0 .466-.608"
      })
    }), jsx("path", {
      fill: "var(--cogs-decorative--".concat(color, "--400)"),
      fillRule: "evenodd",
      d: "M58.844 8.164 28.78 25.52a1 1 0 0 0-.366 1.366l18.43 31.92a1 1 0 0 0 1.365.366l30.062-17.357a40 40 0 0 0 18.683-24.457l.7-2.665a8 8 0 0 0-5.631-9.755l-2.658-.724a40 40 0 0 0-30.522 3.95M71.28 23.417a7.286 7.286 0 1 0 12.62-7.285 7.286 7.286 0 0 0-12.62 7.285",
      clipRule: "evenodd",
      opacity: ".5"
    })]
  }));
};

export { RocketIllustration };
